import React from 'react'

//* HOC's
import { withUIContext } from 'context'

//* Components
import LottieAnimation from 'components/common/LottieAnimation'
import MenuItems from 'components/common/MenuItems'

//* Style
import BurgerMenuStyle from './style'

//* Lottie
import slotMachineBurgerMenu from 'lottieAnimation/slotMachineBurgerMenu.json'

const BurgerMenu = ({ isBurgerMenuOpen }) => {
    return (
        <BurgerMenuStyle>
            <div className={`openMenu FlexBoxColumn ${isBurgerMenuOpen ? 'active' : ''}`}>
                <MenuItems type={'burger'} className={'menu-routes-wrap'} />
                <LottieAnimation
                    className='slotMachineLottie'
                    animData={slotMachineBurgerMenu}
                    autoplay={false}
                    isPlay={isBurgerMenuOpen}
                    loop={true}
                    onCompletePause={!isBurgerMenuOpen}
                />
            </div>
        </BurgerMenuStyle>
    )
}

export default withUIContext(BurgerMenu, ['isBurgerMenuOpen', 'toggleBurgerMenu'])
